import NavBar from './navbar';
import NavMenu from './navmenu';
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as Cases from '../slices/casesSlice';
import ReportSite from './reportsite';
import ReportBricklane from './reportbricklane';
import ReportGarnet from './reportgarnet';
import { AnyAction } from '@reduxjs/toolkit';
import '../App.css';
import { getFormValidWithId, getFormValueWithId, doFormOnChange, handleScroll, validateForm } from '../utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import icon_analytics from '../assets/Analytics_White.svg';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import icon_generate from '../assets/Generate_icon.svg';
import icon_save from '../assets/Save_icon.svg';

const Analytics = () => {
	const cases = useAppSelector(state => state.cases);
	const user = useAppSelector(state => state.user);
	const forms = useAppSelector(state => state.forms);
	const dispatch = useAppDispatch();
	const fid = "ANALYTICS";

	const bSSRS = getFormValueWithId(fid, 'report_site') === '-2';

	const getUrl = (php: string, drill: boolean): string => {
		let url = php + '.php';
		if (drill) {
			const rl = '/Senior Management/DrillThroughs/' + getFormValueWithId(fid, 'report_ssrs') + ' Drillthrough';
			url = url.concat('?report=', encodeURIComponent(rl));
		} else {
			const rl = '/Senior Management/Intro Portal Reports/' + getFormValueWithId(fid, 'report_ssrs');
			url = url.concat('?report=', encodeURIComponent(rl));
		}

		if (user.type === 'introducer') {
			url = url.concat('&introducer=', encodeURIComponent(user.introducer.introducerid));
		}
		if (user.type === 'developer') {
			url = url.concat('&developer=', encodeURIComponent(user.developers[0].developerid));
		}

		return url;
	}
	const handleIfrmeLoad = () => {
		dispatch(Cases.setGenerating(false));
	}

	const generateReport = () => {
		if (validateForm(fid, fid)) {
			dispatch(Cases.setGenerating(true));
			const sv = getFormValueWithId(fid, "report_site");
			if (sv === '-2') {
				dispatch(Cases.setIframeSsrsSrc(process.env.REACT_APP_API_BACKEND_URL + getUrl('getreportssrs', false)) as unknown as AnyAction);
			} else {
				const sel = document.getElementById("report_site") as HTMLSelectElement;
				if (sel) {
					const text = sel.options[sel.selectedIndex].text;
					const setsv = () => new Promise((resolve) => resolve(dispatch(Cases.setReportSV(sv) as unknown as AnyAction)));
					setsv().then(() => dispatch(Cases.getReportData({ sec: user.token, sv: sv, desc: text, idb: user.id }) as unknown as AnyAction));
				}
			}
		}
	}
	const saveReport = () => {
		if (validateForm(fid, fid)) {
			dispatch(Cases.setSaving(true));
			const sv = getFormValueWithId(fid, "report_site");
			if (sv === '-2') {
				dispatch(Cases.getReportSSRS(getUrl('getreportssrsxlsx', true)) as unknown as AnyAction)
			} else {
				const sel = document.getElementById("report_site") as HTMLSelectElement;
				if (sel) {
					const text = sel.options[sel.selectedIndex].text;
					dispatch(Cases.getReportXlsx({ sec: user.token, sv: sv, desc: text, idb: user.id }) as unknown as AnyAction);
				}
			}
		}
	}

	return (
		<div className="Home">
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, height: 96, marginRight: 8 }} src={icon_analytics} alt='Analytics-Icon' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Analytics</div>
							</div>
						</div>
					</div>
				</div>

				<div id="ANALYTICS" style={{ display: 'flex' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px', margin: '0 2px' }}>
						<select style={{cursor: 'pointer'}} data-form-id={fid} data-valid-type="*" className={getFormValidWithId(fid, "report_site") ? undefined : 'error'} value={getFormValueWithId(fid, "report_site")} id='report_site' name='report_site' onChange={(e) => doFormOnChange(e)}>
							<option value=''>Please Select...</option>
							<option value='-2'>SSRS Reports...</option>
						</select>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px', margin: '0 2px' }}>
						<select style={{cursor: 'pointer'}} disabled={!bSSRS} data-form-id={fid} data-valid-type={bSSRS ? '*' : ''} className={getFormValidWithId(fid, "report_ssrs") ? undefined : 'error'} value={getFormValueWithId(fid, "report_ssrs")} id='report_ssrs' name='report_ssrs' onChange={(e) => doFormOnChange(e)}>
							<option value=''>Please Select...</option>
							<option value='Completions'>Completions</option>
							<option value='Exchanges'>Exchanges</option>
							<option value='New Starts'>New Starts</option>
						</select>
					</div>
					<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => generateReport()}>
						<div style={{ width: 28, height: 24 }}>
							<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_generate} alt='Generate-Icon' />
						</div>
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Generate Report</div>
						<div style={{ width: 28, height: 24 }}>
							{cases.report.isGenerating &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => saveReport()}>
						<div style={{ width: 28, height: 24 }}>
							<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_save} alt='Save-Icon' />
						</div>
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Save Report (.xls)</div>
						<div style={{ width: 28, height: 24 }}>
							{cases.report.isSaving &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
				</div>
				<div style={{ height: 'calc(100vh - 369px)', color: 'black' }}>
					{bSSRS &&
						<iframe src={cases.iframeSsrsSrc} style={{ width: '100%', height: '100%' }} onLoad={handleIfrmeLoad} title='SSRS'></iframe>
					}
					<div style={{ height: '100%', overflow: 'scroll' }} onScroll={handleScroll}>
						{getFormValueWithId(fid, "report_site") === 'bricklane' && !(cases.report.isGenerating) &&
							<ReportBricklane />
						}
						{(getFormValueWithId(fid, "report_site") === 'garnet' || getFormValueWithId(fid, "report_site") === 'brickmoor') && !(cases.report.isGenerating) &&
							<ReportGarnet />
						}
						{getFormValueWithId(fid, "report_site") !== 'bricklane' && getFormValueWithId(fid, "report_site") !== 'garnet' && getFormValueWithId(fid, "report_site") !== 'brickmoor' && getFormValueWithId(fid, "report_site") !== '' && getFormValueWithId(fid, "report_site") === cases.report.sv && !(cases.report.isGenerating) && !bSSRS &&
							<ReportSite />
						}
					</div>
				</div>
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Analytics;